import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RolesComponent } from './components/roles/roles.component';
import { UsersComponent } from './components/usuarios/users.component';
import { PermisosComponent } from './components/permisos/permisos.component';
import { RolesAplicacionesComponent } from './components/rolesAplicaciones/roles-aplicaciones.component';
import { AplicacionesComponent } from './components/aplicaciones/aplicaciones.component';
import { AccessPermisionGuard } from 'src/app/guard/accessPermision.guard';
import { ConstantsCatalogosIdService } from 'src/app/services/constants-catalogos-id.service';
import { ElementoNivelPermisoComponent } from './components/elementoNivelPermiso/elementos.nivel.permiso.component';
import { ObservadorComponent } from './components/observador/observador.component';
import { AuthGuard } from 'src/app/guard/auth.guard';
import { LoginGuard } from 'src/app/guard/login.guard';
import { Usuario } from 'src/app/models/usuario.model';
import { DashboardComponent } from './components/dashboard/dashboard.component';

//data:apps -> Almacena los nombres de las aplicaciones que tienen permiso de acceso 
const routesAdmin: Routes = [
  {
    path: '',
    //component: PagesComponent,//Ruta protegida: En PagesComponent se renderiza todo lo de estas rutas de abajo
     canActivate:[AuthGuard],
     canActivateChild:[AuthGuard],
    children: 
    [
      { path: 'roles', component: RolesComponent, data:{title:'Roles', apps:[ConstantsCatalogosIdService.ROLES]}, canActivate:[AccessPermisionGuard]},
      { path: 'usuarios', component: UsersComponent, data:{title:'Usuarios', apps:[ConstantsCatalogosIdService.USUARIOS]}, canActivate:[AccessPermisionGuard]},
      { path: 'permisos', component: PermisosComponent, data:{title:'Permisos', apps:[ConstantsCatalogosIdService.PERMISOS]}, canActivate:[AccessPermisionGuard]},
      { path: 'permisos-niveles-elementos', component: ElementoNivelPermisoComponent, data:{title:'Permisos niveles elementos', apps:[ConstantsCatalogosIdService.ELEMENTOS_NIVELES_PERMISOS]}, canActivate:[AccessPermisionGuard]},
      { path: 'rol-app', component: RolesAplicacionesComponent, data:{title:'Roles-aplicaciones', apps:[ConstantsCatalogosIdService.ROLES_APLICACIONES]}, canActivate:[AccessPermisionGuard]},
      { path: 'aplicaciones', component: AplicacionesComponent, data:{title:'Aplicaciones', apps:[ConstantsCatalogosIdService.APLICACIONES]}, canActivate:[AccessPermisionGuard]},
      { path: 'observador', component: ObservadorComponent, data:{title:'Permisos niveles elementos'}},
      { path: '', component: DashboardComponent,  canActivate:[LoginGuard]},
      //{ path: '', redirectTo: 'dashboard', pathMatch: 'full'},
    //{ path: '', component:RolesComponent, canActivate:[LoginGuard]},
    ]
  },//Para rutas protegidas
];


@NgModule({
  imports: [RouterModule.forChild(routesAdmin)],//Para rutas hijas
  exports: [RouterModule]
})

export class AdminRoutingModule {

}

